import BetRadarWidget from "app/components/BetRadarWidget/BetRadarWidget";
import { IconArrow } from "app/components/Icon/Icon";
import MarketTypeGroupings from "app/components/UnsummarizedMarketsModal/components/ModalMarketTypeGroupings/ModalMarketTypeGroupings";
import { SessionHelper } from "app/helpers/sessionHelper";
import { WidgetHelper } from "app/helpers/widgetHelper";
import {
  geniusScoreboardSports,
  SportsNameType,
  widgetProviders,
} from "app/utils/const";
import { Component } from "react";
import WidgetHeader from "../../components/WidgetHeader/WidgetHeader";
import GeniusWidget from "../GeniusWidget/GeniusWidget";
import "./WidgetAvailable.scss";

type Props = {
  userTimezone: Record<string, any>;
  fetchEventData: Function;
  event: EventType;
  darkMode: boolean;
  widgetExpanded: boolean;
  toggleWidget: (widgetExpanded: boolean) => void;
};

class WidgetAvailable extends Component<Props, State> {
  componentDidMount() {
    this.props.toggleWidget(false); // To ensure widget is collapsed when opening event details
  }
  render() {
    const { event, fetchEventData, darkMode, widgetExpanded, toggleWidget } =
      this.props;
    const provider = event?.widgets?.widgetProvider;
    const sourceFixtureId = WidgetHelper.getSourceFixtureId(event.widgets);
    const isWidgetExpanable = !(
      event.sportType === SportsNameType.CRICKET ||
      geniusScoreboardSports.includes(event?.sportType)
    );

    return (
      <div className="widget-available">
        <WidgetHeader event={event} fetchEventData={fetchEventData} />

        {!SessionHelper.isAsianRouteAndSessionView() &&
          event &&
          provider === widgetProviders.BETRADAR &&
          sourceFixtureId && (
            <div className="unsummarized-markets__betradar-widget">
              <BetRadarWidget
                showHomePlayerAsFirst={event.showHomePlayerAsFirst}
                sourceFixtureId={sourceFixtureId}
              />
            </div>
          )}

        {!SessionHelper.isAsianRouteAndSessionView() &&
          provider === widgetProviders.GENIUSSPORTS &&
          sourceFixtureId && (
            <GeniusWidget
              darkMode={darkMode}
              sportType={event.sportType}
              sourceFixtureId={sourceFixtureId}
              standAloneSection={widgetExpanded ? "" : "scoreboard"}
            />
          )}

        {isWidgetExpanable &&
          !SessionHelper.isAsianRouteAndSessionView() &&
          provider === widgetProviders.GENIUSSPORTS &&
          sourceFixtureId && (
            <div
              className={`widget-available__expand-button ${
                widgetExpanded ? "arrow-up" : "arrow-down"
              }`}
              onClick={() => {
                toggleWidget(!widgetExpanded);
              }}
            >
              <IconArrow />
            </div>
          )}

        {!SessionHelper.isAsianRouteAndSessionView() && (
          <MarketTypeGroupings event={event} sportId={event["sportId"]} />
        )}
      </div>
    );
  }
}

export default WidgetAvailable;
